/** @format */

export default {
  root: {
    '& input, & textarea': {
      fontFamily: 'Vazir',
    },
    '& .MuiInputBase-root': {
      borderRadius: 8,
      border: '1px solid #dfdfdf',
      '&.Mui-focused': {
        backgroundColor: '#fff',
        border: '1px solid #2B3990 !important',
        '& .MuiInputAdornment-positionStart': {
          '& div': {
            color: '#2b3990!important',
          },
        },
      },
    },
    '& fieldset': {
      border: 'none !important',
      background: 'none',
    },
  },
};
